<template>
  <div class="lv-download-file-btn">
    <div>
      <slot name="header"></slot>
      <LvImgPreviewBtn
        v-if="isImageViewable && _isTypeImg"
        :id="id"
        :url="url"
        :module="module"
        :num="num"
        :name="name"
        :hasScope="hasScope"
        :isSystem="isSystem"
        :showDeleteBtn="showDeleteBtn"
        :isLoading="isLoading"
        :showMoreBtn="showMoreBtn"
        :showDownloadBtn="showDownloadBtn"
        :fileType="fileType"
        :versionNumber="versionNumber"
        class="ma-4"
        @go-to="$emit('go-to', $event)"
        @remove="$emit('remove')"
      />
      <div
        v-else
        class="lv-download-file-btn__content"
        :class="{
          small,
          narrow,
          download: download && showDownloadBtn,
          'is-loading': isLoading,
          'disable-hover': _hideHover,
        }"
        @click.stop="$_onClickFile(num)"
        @mouseenter="$_onMouseEnter"
        @mouseleave="$_onMouseLeave"
      >
        <img :src="$_setFileIcon()" alt="" class="lv-download-file-btn__content-img" />
        <div class="lv-download-file-btn__file-name-wrapper">
          <LvText ref="fileName" bold noWrap class="file-name">
            {{ versionNumber ? `${name} ver.${versionNumber}` : name }}
          </LvText>
          <LvTooltip
            v-if="showTooltip && isTextTruncated"
            :value="versionNumber ? `${name} ver.${versionNumber}` : name"
            class="lv-download-file-btn__tooltip"
          />
        </div>
        <div v-if="chipList && chipList.length">
          <WsChips001 :value="chipList" class="my-16 ml-20" />
        </div>
        <div v-if="!small" class="lv-download-file-btn__icon">
          <i
            v-if="download && hasScope && showDownloadBtn"
            class="icon icon-cloud-download"
            @click.stop="$_onDownload(url)"
          />
          <i v-if="_showDeleteBtn" class="icon icon-cancel" @click.stop="$_onClickDelete()" />
          <i v-if="showMoreBtn & hasScope" class="icon icon-more" @click.stop="$_onClickMore()" />
        </div>
        <div v-if="isLoading && !mouseShowDeleteBtn" class="is-loading-wrap">
          <LoadingAnimate primary />
        </div>
      </div>
    </div>
    <LvPopupPreview
      :ref="'popup' + num"
      :num="num"
      :url="url"
      :name="name"
      :fileType="fileType"
      :download="download && showDownloadBtn"
      :showMoreBtn="showMoreBtn"
      :popUpActive="isActive.previewPopup"
      :versionNumber="versionNumber"
      @click="$_onClosePopup('previewPopup')"
      @go-to="$_onClickMore()"
    />
    <LvPopupDeleteFile
      ref="LvPopupDeleteFile"
      :id="id"
      :module="module"
      :isSystem="isSystem"
      @remove="$emit('remove')"
    />
    <PopUp
      bottom
      title="您沒有此檔案所屬資料夾的權限"
      :popUpActive="isActive.noScopePopup"
      @click="$_onClosePopup('noScopePopup')"
    >
      <template v-slot:bottomBtn>
        <WsButton001 @click="$_onClosePopup('noScopePopup')">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>
<script>
import S_file from '@/service/api/v1/file';
import H_file from '@/helpers/file';

export default {
  props: {
    narrow: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: true,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    num: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    chipList: {
      type: Array,
    },
    fileType: {
      type: String,
    },
    hasScope: {
      type: Boolean,
      default: false,
    },
    versionNumber: {
      type: [String, Number],
    },
    module: {
      type: String,
    },
    id: {
      type: String,
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    showMoreBtn: {
      type: Boolean,
      default: true,
    },
    showDownloadBtn: {
      type: Boolean,
      default: true,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
    saveToStorage: {
      type: Boolean,
      default: false,
    },
    isImageViewable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: {
        previewPopup: false,
        noScopePopup: false,
      },
      mouseShowDeleteBtn: false,
      showTooltip: false,
      isTextTruncated: false,
    };
  },
  computed: {
    _showDeleteBtn() {
      if (!this.showDeleteBtn) return false;
      return this.showDeleteBtn || (this.upload && !this.isLoading) || this.mouseShowDeleteBtn;
    },
    _hideHover() {
      return !this.isClickable && !this.upload;
    },
    _isTypeImg() {
      return H_file.isTypeImg(this.fileType);
    },
  },
  methods: {
    $_setFileIcon() {
      return H_file.setFileIcon(this.fileType, this.url);
    },
    $_onClosePopup(type) {
      if (type === 'previewPopup') {
        this.$emit('click');
        this.$emit('scroll-click');
      }
      this.isActive[type] = false;
    },
    $_onOpenPopup(type) {
      if (type === 'previewPopup') {
        this.$emit('click');
        this.$emit('no-scroll');
      }
      this.isActive[type] = true;
    },
    async $_onDownload(url) {
      if (!url || !this.name || !this.fileType) {
        this.$store.dispatch('downloadPopup/open');
        this.$store.dispatch('downloadPopup/showError', '下載失敗，請稍後再試');
        return;
      }
      await S_file.download(url, this.name, this.fileType, this.versionNumber);
      this.$emit('download-end');
    },
    async $_onClickDelete() {
      if (this.saveToStorage) this.$emit('remove');
      else await this.$refs.LvPopupDeleteFile.$_onOpenPopup('popup');
    },
    $_onClickMore() {
      this.$emit('go-to', this.id);
    },
    $_onClickFile(num) {
      if (!this.isClickable || this.isLoading) return;
      if (this.hasScope) this.$_onOpenPopup('previewPopup', num);
      else this.$_onOpenPopup('noScopePopup');
    },
    $_checkTextTruncated() {
      this.$nextTick(() => {
        if (!this.$refs.fileName || !this.$refs.fileName.$el) {
          this.isTextTruncated = false;
          return;
        }
        const fileNameEl = this.$refs.fileName.$el;
        // 檢查多行 ellipsis (scrollHeight) 或單行 ellipsis (scrollWidth)
        this.isTextTruncated =
          fileNameEl.scrollHeight > fileNameEl.clientHeight ||
          fileNameEl.scrollWidth > fileNameEl.clientWidth;
      });
    },
    $_onMouseEnter() {
      this.mouseShowDeleteBtn = true;
      if (!this.$refs.fileName || !this.$refs.fileName.$el) return;
      const fileNameEl = this.$refs.fileName.$el;
      // 立即檢查文字是否被截斷
      const truncated =
        fileNameEl.scrollHeight > fileNameEl.clientHeight ||
        fileNameEl.scrollWidth > fileNameEl.clientWidth;
      this.isTextTruncated = truncated;
      if (truncated) {
        this.showTooltip = true;
      }
    },
    $_onMouseLeave() {
      this.mouseShowDeleteBtn = false;
      this.showTooltip = false;
    },
  },
  mounted() {
    this.$_checkTextTruncated();
  },
  updated() {
    this.$_checkTextTruncated();
  },
};
</script>
